export enum IPersonalityType {
  Individual = 1, // حقیقی
  Corporate = 2, // حقوقی
}

export interface ILicenseInfo {
  guid: string;
  personality_type: IPersonalityType;
  license_number: string | null;
  license_expiration_date: string;
  license_issuance_date: string;
  company_name: string | null;
  national_company_code: string | null;
  registration_number: string | null;
  first_legal_representative_name: string | null;
  first_legal_representative_code: string | null;
  first_legal_representative_phone_number: string | null;

  second_legal_representative_name: string | null;
  second_legal_representative_code: string | null;
  second_legal_representative_phone_number: string | null;
}

export interface IStoreDetails {
  phone_number: string;
  address: string;
  postal_code: string | null;
  license_info: ILicenseInfo;
  title: string;
}

export interface IUserData {
  name: string;
  national_code: string | null;
  store: IStoreDetails;
}
